import { string } from 'yup';

const rule = {
	name: 'containsAtLeastOneDigit',
	method ({ message } = { message: 'Your password must contain at least one digit' }) {

		return this.test('containsAtLeastOneDigit', message, function (value) {

			const { path, createError } = this;
			return /[0-9]/.test(value) || createError({ path, message });

		});

	},
	schemaType: string
};

export default rule;
